/* eslint-disable import/prefer-default-export */
import { createAction } from 'redux-actions';
// Action Declarations
// Suggested Action Name Standard: ORG_MODULE_ACTION_ANY
export const getSystemSettingsAction = createAction('APP_SETTINGS_GET_SYSTEM_SETTINGS');
export const editSystemSettingsAction = createAction('APP_SETTINGS_EDIT_SYSTEM_SETTINGS');
